import type { ComponentProps } from "react";

import type { ArtSectionType } from "@features/home-art-sections/model";

import type { ColorIconType } from "@shared/content-types/types";
import { BrandIcon } from "@shared/ui/brand-icon";
import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Icon } from "@shared/ui/icon";
import { Image } from "@shared/ui/image";
import { Heading } from "@shared/ui/typography";

import s from "./third-type.module.scss";

export type ThirdTypeProps = ComponentProps<"div"> & {
  data: ArtSectionType;
  pageIcon: ColorIconType;
};

export const ThirdType = (props: ThirdTypeProps) => {
  const {
    data: { title, buttonText, buttonLink, mainImage, icon },
    pageIcon,
  } = props;

  return (
    <div className={s.root}>
      <div className={s.info}>
        {icon?.icon?.name && (
          <BrandIcon
            name={icon.icon.name}
            fillColor={icon.fillColor ?? "gold"}
            strokeColor={icon.strokeColor ?? "bistre"}
            className={s.infoIcon}
          />
        )}
        {title && (
          <Heading level={6} tag="h3" className={s.title}>
            {title}
          </Heading>
        )}
        {buttonLink && buttonText && (
          <ButtonWithIcon
            href={buttonLink}
            variant="primary-dark"
            iconFillColor={pageIcon?.fillColor}
            iconStrokeColor={pageIcon?.strokeColor}
            iconName={pageIcon?.icon?.name ?? "plus"}
            iconSvgCode={pageIcon?.uicon?.svg_code}
            className={s.button}
          >
            {buttonText}
          </ButtonWithIcon>
        )}
      </div>
      <div className={s.images}>
        {mainImage?.url && (
          <Image
            src={mainImage.url}
            alt={mainImage?.alternativeText ?? "art image"}
            height="100%"
            className={s.mainImage}
          />
        )}
      </div>
    </div>
  );
};

ThirdType.displayName = "ThirdType";
